import { useState } from "react";
import { send_pin_code_api } from "../../DAL/Users";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react";
import SubmitButton from "../GeneralComponents/SubmitButton";

export default function SendPinCode(props) {
  const {
    formData,
    setFormData,
    setErrors,
    errors,
    setFormState,
    handleLogin,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    const postData = { email: formData.email };
    const result = await send_pin_code_api(postData);
    if (result.code === 200) {
      setFormState(1);
    } else {
      toast.error(`${result.message}`);
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <div className="input-wrapper">
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            className={`ps-3 ${errors.email ? "has-error" : ""}`}
          />
        </div>
        {errors.email && (
          <span className="error-message">
            <Icon icon="mdi:alert-circle" className="error-icon" />
            {errors.email}
          </span>
        )}
      </div>
      <div className="forget-password mt-2">
        <span className="login-forget-password" onClick={handleLogin}>
          Back to login?
        </span>
      </div>
      <SubmitButton
        isLoading={isLoading}
        btnText="Send OTP"
        loadingText="Sending..."
      />
    </form>
  );
}
